import round from 'lodash/round';

// A refund line holds a full-line "base" value (amount or tax). The dollars actually
// refunded = base * (refundQty / sourceQty), rounded to cents. Mirrors the Work Order
// tax convention (see Edit.vue getItemTax / fulfilledQtyChanged).
function applied(base, qty, sourceQty) {
    if (!qty || !sourceQty) {
        return 0;
    }
    return round((base || 0) * (qty / sourceQty), 2);
}

// The most that may be refunded for `qty` units of a line whose full-line source value
// is `sourceValue` over `sourceQty` units. Equals applied() with base = sourceValue.
function maxApplied(sourceValue, qty, sourceQty) {
    return applied(sourceValue, qty, sourceQty);
}

// Inverse of applied(): given an applied value, recover the full-line base so later
// qty changes rescale consistently. Used to store tax-service results back onto a line.
function baseFromApplied(appliedValue, qty, sourceQty) {
    if (!qty || !sourceQty) {
        return 0;
    }
    return round((appliedValue || 0) * (sourceQty / qty), 2);
}

function lineRefundTotal(baseAmount, baseTax, qty, sourceQty) {
    return applied(baseAmount, qty, sourceQty) + applied(baseTax, qty, sourceQty);
}

export default {
    applied,
    maxApplied,
    baseFromApplied,
    lineRefundTotal,
};
